import { Box, Flex, HStack, Image, Link as ChakraLink, Stack, Text } from '@chakra-ui/react';
import { Link as RouterLink } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { useBrand } from '../branding/useBrand';
import { SocialLinks } from './SocialLinks';

const FOUNDED = 2012;

const footerLinkStyle = {
  color: 'whiteAlpha.900',
  _hover: { color: 'white', textDecoration: 'underline' },
} as const;

export function PublicFooter() {
  const { t } = useTranslation();
  const brand = useBrand();
  const currentYear = new Date().getFullYear();
  const years = `${FOUNDED}-${currentYear}`;

  return (
    <Box as="footer" bg="#7B4F4A" color="whiteAlpha.900" mt={20} py={10} px={6}>
      <Flex
        maxW="1200px"
        mx="auto"
        align={{ base: 'center', md: 'flex-start' }}
        justify="space-between"
        gap={8}
        direction={{ base: 'column', md: 'row' }}
      >
        <Stack spacing={1} fontSize="sm" align={{ base: 'center', md: 'flex-start' }}>
          <ChakraLink as={RouterLink} to="/about" {...footerLinkStyle}>{t('footer.about')}</ChakraLink>
          <ChakraLink as={RouterLink} to="/contact" {...footerLinkStyle}>{t('footer.contact')}</ChakraLink>
          <ChakraLink as={RouterLink} to="/terms" {...footerLinkStyle}>{t('footer.terms')}</ChakraLink>
          <ChakraLink as={RouterLink} to="/privacy" {...footerLinkStyle}>{t('footer.privacy')}</ChakraLink>
        </Stack>
        <Image src={brand.logoSrc} alt={brand.name} h="56px" opacity={0.9} />
        <Stack spacing={3} fontSize="sm" align={{ base: 'center', md: 'flex-end' }}>
          <Text fontWeight={700}>app.mixgenie.ai</Text>
          <SocialLinks />
          <Text>{t('footer.copyright', { years })}</Text>
        </Stack>
      </Flex>
    </Box>
  );
}
